import { getContentType, getLanguae, getCmsDomain } from 'common/util'
import request, { ResponseData } from './request'
import { has, isArray, omit, pick } from 'lodash'

const Omits = [
  'createdAt',
  'locale',
  'pn',
  'publishedAt',
  'updatedAt',
  'banner',
  'tabs',
  'logo',
  'type',
  'background',
  'color',
]

export enum IGuideComponentType {
  Article = 'global.tutorial-article-tab',
  Video = 'global.tutorial-video-tab',
}

export enum IGuideFeatureLayout {
  Vertical = 'vertical',
  Grid = 'grid',
}

export interface IGuideArticle {
  id: number
  title: string
  __component: string
  listing: Array<ContentItem>
  layout?: string
  storeId?: string
}

export interface ContentItem {
  id: number
  title: string
  uid?: string | null
  store: string
  pn?: string
  image?: string
  updatedAt?: string
  countries?: string
  storeId?: string
}

export interface ListingItem {
  contents: string
  id: number
}

export interface IGuideVideo {
  id: number
  title: string
  __component: string
  listing: Array<{
    id: number
    title: string
    value: string
  }>
  layout?: string
  isShowSeeAll?: boolean
  link?: string
  moreTitle?: string
  description?: string
}

export interface IGuide {
  title: string
  banner?: Array<{ url: string; name: string }>
  locale?: string
  tabs: Array<IGuideArticle | IGuideVideo>
}

interface GetGuideResponse {
  data: {
    data: {
      id: number
      attributes: {
        title: string
        subtitle: string
        banner: {
          data: Array<{
            id: number
            attributes: {
              url: string
              name: string
            }
          }>
        }
        tabs: Array<
          {
            __component: string
            id: number
            title: string
            layout: string
            listing: any
          } & { [k: string]: any }
        >
      }
    }
  }
}

// 获取视频文章页面数据
const getCategotiesList = async (params: { uid?: string }) => {
  const content_type = await getContentType()
  const lang = getLanguae()

  const link = `${await getCmsDomain()}/v1/cms_service/cms/get_category_page`

  const _params = { ...params, content_type: content_type.categoties, lang }
  return request<ResponseData<GetGuideResponse>>(
    link,
    {
      method: 'POST',
      data: _params,
    },
    {
      ignoreAuthToken: true,
    }
  )
    .then(res => {
      if (res.code === 0 && has(res, 'data.data.data.attributes')) {
        return res.data.data.data.attributes
      } else {
        return Promise.reject(null)
      }
    })
    .then(res => {
      let { banner: _banner, tabs: _tabs, locale } = res
      // banner 处理
      const banner =
        _banner.data && !_banner.data.length
          ? [pick(_banner.data.attributes, ['url', 'name'])]
          : _banner.data?.map((item: { attributes: any }) => pick(item.attributes, ['url', 'name'])) || []

      // tabs 处理
      const tabslist = _tabs.map((item: any) => {
        // Article
        if (item.__component === IGuideComponentType.Article) {
          if (item.listing && isArray(item.listing)) {
            item.listing = item.listing.reduce((acc: ContentItem[], item: ListingItem) => {
              const contentsArray = JSON.parse(item.contents)
              return acc.concat(contentsArray)
            }, [])
          }
        }

        return item
      })
      const tabs = []
      tabs.push(tabslist[0])
      return { banner, tabs, locale, ...omit(res, Omits) } as IGuide
    })
}

export default getCategotiesList
